import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-[calc(100vh-4rem)] flex items-center justify-center"
            >
                <div className="flex items-center gap-3 text-muted-foreground text-sm">
                    <Loader2 className="size-4 animate-spin" />
                    Caricamento in corso…
                </div>
            </div>
        );
    }

    if (user === false) {
        const redirect = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?redirect=${redirect}`} replace />;
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
